module.exports = __webpack_public_path__ + "static/media/marker.096117a2.svg";